(function () {
  'use strict';

  if (window.metaboxMwNormalize) return;

  function asString(value) {
    if (value === null || value === undefined) return '';
    return String(value).trim();
  }

  function normalizeOptionName(name) {
    if (!name) return '';
    return name
      .toString()
      .trim()
      .toLowerCase()
      .replace(/^\d+[\).\-\s]*/, '')
      .replace(/[_/]+/g, ' ')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\band\b/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeEntityName(name) {
    if (!name) return '';
    return name
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[_/]+/g, ' ')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\band\b/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function extractMeaningfulLookupText(value) {
    const text = asString(value);
    if (!text) return '';
    if (/^https?:\/\//i.test(text)) return '';
    return text;
  }

  function normalizeMaterialLookupName(name) {
    const normalized = normalizeEntityName(name);
    if (!normalized) return '';

    return normalized.replace(/([a-z])\d+$/i, '$1').trim();
  }

  function decodeHtmlEntities(value) {
    const textValue = asString(value);
    if (!textValue || !textValue.includes('&')) return textValue;

    const textarea = document.createElement('textarea');
    textarea.innerHTML = textValue;
    return textarea.value.trim();
  }

  function pickPreferredNormalizedMatch(matches, isPreferredMatch) {
    if (!Array.isArray(matches) || !matches.length) return null;
    if (typeof isPreferredMatch !== 'function') return matches[0] || null;

    return matches.find((match) => isPreferredMatch(match)) || matches[0] || null;
  }

  function findBestNormalizedMatch(items, normalizedTargetValue, getItemName, isPreferredMatch) {
    if (!Array.isArray(items) || !normalizedTargetValue || typeof getItemName !== 'function') return null;

    const exactMatches = items.filter((item, index) => {
      const normalizedItemName = getItemName(item, index);
      return normalizedItemName && normalizedItemName === normalizedTargetValue;
    });

    if (exactMatches.length) {
      return pickPreferredNormalizedMatch(exactMatches, isPreferredMatch);
    }

    const partialMatches = items.filter((item, index) => {
      const normalizedItemName = getItemName(item, index);
      if (!normalizedItemName) return false;

      return (
        normalizedItemName.includes(normalizedTargetValue) ||
        normalizedTargetValue.includes(normalizedItemName)
      );
    });

    if (!partialMatches.length) return null;

    return pickPreferredNormalizedMatch(partialMatches, isPreferredMatch);
  }

  function getMwValueSwatchTitle(mwValue) {
    if (!mwValue) return '';
    const swatchImage = mwValue.querySelector('.mw-option__swatch-image');
    return swatchImage ? extractMeaningfulLookupText(swatchImage.getAttribute('title')) : '';
  }

  function getMwValueLabel(mwValue, index) {
    if (!mwValue) return `mw-value-${index + 1}`;

    const swatchTitle = getMwValueSwatchTitle(mwValue);
    if (swatchTitle) return swatchTitle;

    const swatchImage = mwValue.querySelector('.mw-option__swatch-image');
    const swatchAlt = swatchImage ? extractMeaningfulLookupText(swatchImage.getAttribute('alt')) : '';
    if (swatchAlt) return swatchAlt;

    const label =
      mwValue.querySelector('.mw-option__label') ||
      mwValue.querySelector('.mw-text') ||
      mwValue.querySelector('label');
    const labelText = label && label.textContent ? label.textContent.trim() : '';
    if (labelText) return labelText;

    const input = mwValue.querySelector('input.mw-option__control');
    if (input) {
      const inputValue = (input.value || '').trim();
      if (inputValue) return inputValue;
    }

    return `mw-value-${index + 1}`;
  }

  function getMaterialLabel(material, index) {
    if (!material) return `material-${index + 1}`;
    const title = material.title ? String(material.title).trim() : '';
    if (title) return title;
    const id = material.id ? String(material.id).trim() : '';
    if (id) return id;
    return `material-${index + 1}`;
  }

  window.metaboxMwNormalize = {
    asString,
    normalizeOptionName,
    normalizeEntityName,
    normalizeMaterialLookupName,
    decodeHtmlEntities,
    extractMeaningfulLookupText,
    pickPreferredNormalizedMatch,
    findBestNormalizedMatch,
    getMwValueSwatchTitle,
    getMwValueLabel,
    getMaterialLabel,
  };
})();
